export enum VersionStateType {
	Active = 1,
	Draft = 2,
	Archive = 3,
	PrePublication = 4,
	ActiveDeleted = 5,
	DraftDeleted = 6,
	ArchiveDeleted = 7,
	PrePublicationDeleted = 8
}